/* Copyright 2020 Avetti.com Corporation - All Rights Reserved

This source file is subject to the Avetti Commerce Front End License (ACFEL 1.20)
that is accessible at https://www.avetticommerce.com/license */ import React, {
  useEffect,
  useContext,
} from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";

import { fetchCategoryFromDirectUrl } from "../../redux/actions/categoryActions";

import GoogleLocationBox from "./GoogleLocationBox";

import { I18nContext } from "../../i18n";

import Modal from "@material-ui/core/Modal";

import classes from "./Styles/LocationBar.module.css";
import DialogContent from "@material-ui/core/DialogContent";

const LocationBar = () => {
  const { langCode, translate } = useContext(I18nContext);

  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);

  const geoLocationState = useSelector(
    (state) => state.geoLocationReducer.geoLocation,
    shallowEqual
  );

  const userInfoState = useSelector(
    (state) => state.loginReducer.userInfo,
    shallowEqual
  );
  const userLocationState = useSelector(
    (state) => state.userLocationReducer,
    shallowEqual
  );

  const distanceState = useSelector(
    (state) => state.categoryReducer.distance,
    shallowEqual
  );

  const isMobileState = useSelector(
    (state) => state.mainReducer.isMobile,
    shallowEqual
  );

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (
      (geoLocationState && geoLocationState.lat,
      geoLocationState.long && !geoLocationState.initial)
    ) {
      localStorage.setItem(
        "userLocationGoogleAPI",
        JSON.stringify(geoLocationState)
      );
      // If user entered value, store in seprate localStorage key so that we can go back to this value
      if (geoLocationState && geoLocationState.userInput) {
        localStorage.setItem(
          "userLocationUserInputBackup",
          JSON.stringify(geoLocationState)
        );
      }

      dispatch(fetchCategoryFromDirectUrl());
    }
  }, [geoLocationState]);

  const renderProvince = () => {
    return userLocationState.state != userLocationState.city
      ? userLocationState.state
      : userLocationState.country;
  };

  const renderLocationBarText = () => {
    if (distanceState != null) {
      return (
        <div className={classes.location}>
          <span className={classes.locationText}>
            {`${isMobileState ? "" : translate("Showing")}` +
              ` ${translate("Sellers Within")}` +
              ` ${distanceState} KM ` +
              translate("of") +
              ` - ${userLocationState.postal}`}
          </span>

          <span className={classes.city}>
            {userLocationState.city}, {renderProvince()}
          </span>
        </div>
      );
    } else {
      return (
        <div className={classes.location}>
          <span className={classes.locationText}>
            {translate("Showing All Sellers")}
          </span>
        </div>
      );
    }
  };

  return (
    <div
      id="locationGrid"
      className={classes.container}
      style={{
        display: "none",
      }}
    >
      <div className={classes.wrapper}>
        {renderLocationBarText()}
        <div
          id="locationChangeBtn"
          className={classes.locationChangeBtn}
          onClick={handleOpen}
        >
          {translate("Change")}
        </div>
      </div>
      <Modal
        aria-labelledby="geolocation-modal"
        aria-describedby="google-geolocation-form"
        open={open}
        onClose={handleClose}
        onEscapeKeyDown={handleClose}
      >
        <DialogContent className="locationbox-wrapper">
          <GoogleLocationBox close={handleClose} />
        </DialogContent>
      </Modal>
    </div>
  );
};

export default LocationBar;
